import { getUnreadNewsCountApi } from "constants/ApiConst";
import { useSwr } from "hooks/useSwr";

type UnreadNewsCountResponse = {
  count: number;
};

const useFetchUnreadNewsCount = () => {
  const { data, error, mutate, isValidating } = useSwr<UnreadNewsCountResponse>(getUnreadNewsCountApi().url, {
    revalidateIfStale: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
  });

  return {
    unreadCount: data?.count ?? 0,
    isLoading: isValidating,
    isValidating,
    error,
    mutate,
  };
};

export default useFetchUnreadNewsCount;
